// 常用的mimeType 需要单独枚举并导出
export var MimeType = /*#__PURE__*/function (MimeType) {
  MimeType["Doc"] = "application/vnd.tdocs-apps.doc";
  MimeType["Sheet"] = "application/vnd.tdocs-apps.sheet";
  MimeType["Form"] = "application/vnd.tdocs-apps.form";
  MimeType["Folder"] = "application/vnd.tdocs-apps.folder";
  MimeType["CollaborationSpace"] = "application/vnd.tdocs-apps.collaboration-space";
  MimeType["CollaborationSpaceRoot"] = "application/vnd.tdocs-apps.collaboration-space-root";
  MimeType["SharedFolder"] = "application/vnd.tdocs-apps.shared-folder";
  MimeType["Share"] = "application/vnd.tdocs-apps.share-folder";
  MimeType["Slide"] = "application/vnd.tdocs-apps.slide";
  MimeType["Pdf"] = "application/pdf";
  MimeType["Aio"] = "application/vnd.tdocs-apps.aio";
  MimeType["SmartCanvas"] = "application/vnd.tdocs-apps.smartcanvas";
  MimeType["SmartSheet"] = "application/vnd.tdocs-apps.smartsheet";
  MimeType["Mind"] = "application/vnd.tdocs-apps.mind";
  MimeType["FlowChart"] = "application/vnd.tdocs-apps.flowchart";
  MimeType["Board"] = "application/vnd.tdocs-apps.board";
  MimeType["Rec"] = "application/vnd.tdocs-apps.rec";
  MimeType["Word"] = "application/vnd.ms-word";
  MimeType["Excel"] = "application/vnd.ms-excel";
  MimeType["Powerpoint"] = "application/vnd.ms-powerpoint";
  MimeType["Txt"] = "text/plain";
  MimeType["Pixso"] = "application/vnd.tdocs-addon-image.236b7f64e91e40b584f2aae0517ee1ed";
  MimeType["Boardmix"] = "application/vnd.tdocs-addon-image.e3e96c1968114db986a9229003965853";
  MimeType["Zhiying"] = "application/vnd.tdocs-addon-image.9e2c26161b684629a9bf29e52efa6c60";
  MimeType["Code"] = "code";
  MimeType["Default"] = "application/vnd.tdocs-apps.default";
  MimeType["Image"] = "image";
  MimeType["Audio"] = "audio";
  MimeType["Video"] = "video";
  MimeType["Zip"] = "application/zip";
  MimeType["Ofd"] = "application/vnd.tdocs-apps.ofd";
  MimeType["DriveOfd"] = "application/ofd";
  MimeType["Markdown"] = "application/vnd.tdocs-apps.markdown";
  MimeType["Markdown_ASCII"] = "text/markdown";
  MimeType["Markdown_UTF8"] = "text/markdown; charset=utf-8";
  MimeType["XMind"] = "xmind";
  MimeType["Visio"] = "visio";
  MimeType["Safe"] = "application/vnd.tdocs-apps.safe-folder";
  return MimeType;
}({});
//# sourceMappingURL=mime-type.js.map